import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useFirestore } from "../firebase/FirestoreContext";
import { collection, getDocs } from "firebase/firestore";
import { EnvContext } from "../context/EnvContext";
import Cookies from "js-cookie";
import config from "../config";
import { positions } from "@mui/system";

const CustomModals = () => {
  const environment = useContext(EnvContext);
  const db = useFirestore();
  const location = useLocation();
  const [modals, setModals] = useState([]);
  const [activeModal, setActiveModal] = useState(null);

  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  useEffect(() => {
    if (!db) return;
    const fetchModals = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, `${collectionPath}Modals/CustomModals/DataBase`));
        const modalList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        // Find first active modal that hasn't been seen
        const matchedModal = modalList.find((modal) => {
          return modal.active && !Cookies.get(`modal_seen_${modal.id}`);
        });

        if (matchedModal) {
          setActiveModal(matchedModal);
        }

        setModals(modalList); // Still keeping the full list for reference
      } catch (error) {
        console.error("Error fetching modals:", error);
      }
    };

    fetchModals();
  }, [db]);

  const handleClose = () => {
    if (activeModal?.showOnce) {
      Cookies.set(`modal_seen_${activeModal.id}`, "true", { expires: 365 });
    }
    setActiveModal(null);
  };

  const handleActionClick = (event) => {
    event.preventDefault(); // Prevent default anchor behavior

    if (!activeModal?.targetUrl) return;

    let finalUrl = activeModal.targetUrl.trim();

    try {
      // If it's a full URL (starting with http/https), use it as-is
      if (/^https?:\/\//.test(finalUrl)) {
        finalUrl = new URL(finalUrl).href;
      } else {
        // Otherwise, assume it's a relative path and prepend window.location.origin
        finalUrl = `${window.location.origin}/${finalUrl.replace(/^\/+/, "")}`;
      }

      // Open the validated URL in a new tab
      window.open(encodeURI(finalUrl), "_self", "noopener,noreferrer");

      // Set cookie to prevent showing the modal again

      Cookies.set(`modal_seen_${activeModal.id}`, "true", { expires: 365 });

      setActiveModal(null);
    } catch (error) {
      console.error("Invalid URL:");
      console.error(error);
    }
  };

  if (!activeModal) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <div onClick={handleClose} style={styles.closeButton}>
          ✕
        </div>
        <h2>{activeModal?.title}</h2>
        {activeModal?.imageUrl && <img src={activeModal.imageUrl} alt={activeModal.title} style={{ maxWidth: "100%" }} />}
        <p>{activeModal?.content}</p>
        {activeModal?.targetUrl && (
          <a href="#" onClick={handleActionClick} rel="noopener noreferrer" style={styles.modalButton}>
            {activeModal.actionButtonText}
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1001,
  },
  modalContent: {
    background: "white",
    padding: "20px",
    paddingTop: "40px",
    borderRadius: "8px",
    textAlign: "center",
    maxWidth: "400px",
    position: "relative",
  },
  modalButton: {
    display: "inline-block",
    marginTop: "10px",
    padding: "10px 20px",
    background: "black",
    color: "white",
    textDecoration: "none",
    borderRadius: "5px",
  },
  closeButton: {
    position: "absolute",
    display: "block",
    marginTop: "15px",
    color: "black",
    border: "none",
    padding: "8px 16px",
    cursor: "pointer",
    borderRadius: "4px",
    right: 5,
    top: 0,
  },
};

export default CustomModals;
